import styled, { css } from 'styled-components';
import { transparentize, lighten, darken } from 'polished';

interface TdFlagProps {
  $isGe?: boolean;
  isIndisponivel?: boolean;
  isSelected?: boolean;
  size?: string;
}
export const Container = styled.div`
  /* background: ${props => props.theme.cardBackgroud}; */
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;


  >header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    div{
      display: flex;
      align-items: center;
      min-width: 250px;
      width: 100%;
    }
    h4{
      min-width: 130px;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;

  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 0px 10px 0px;
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;
      }
    }
  }

  tbody {
    tr {
      cursor: pointer;
      z-index: 1;
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        z-index: 2;
        padding: 10px 0px;

        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};

        button {
          margin: 0;
        }
      }

      &:hover {
        transition: all 0.25s ease;
        ${props =>
          props.theme.name === 'dark'
            ? css`
                background-color: ${props =>
                  lighten(0.03, props.theme.cardBackgroud)};
              `
            : css`
                background-color: ${props =>
                  darken(0.03, props.theme.cardBackgroud)};
              `}
      }
    }
  }
`;

// export const Align = styled.div`
//   justify-content: ${({ align }) =>
//     align === 'right' ? 'flex-end' : 'flex-start'};

//   display: flex;
//   color: ${props => props.theme.fontColor};
//   font-size: 1.0625rem;
//   font-weight: 400 !important;
// `;
export const TdFlag = styled.td<TdFlagProps>`
  width: ${props => props.size + 'rem'};
  font-size: 1.0625rem;
  color: ${props => props.theme.fontColor};
  padding: 0 !important;

  div {
    margin-right: 5px;
    width: 10px;
    height: 40px;

    ${props =>
      props.$isGe && !props.isIndisponivel
        ? css`
            background: ${props.theme.button.warn.in};
          `
        : !props.$isGe && props.isIndisponivel
        ? css`
            background: ${props.theme.button.danger.out};
          `
        : props.$isGe && props.isIndisponivel
        ? css`
            background-image: linear-gradient(
              ${props.theme.button.danger.out},
              ${props.theme.button.warn.in}
            );
          `
        : props.isSelected
        ? css`
            background: ${props.theme.button.success.in};
          `
        : css`
            pointer-events: none;
          `}
  }
`;

// export const Td = styled.td`
//   padding: 10px 10px 10px 0px !important;
//   width: ${props => props.size + 'rem'};
//   font-size: 1.0625rem;
//   color: ${props => props.theme.fontColor};

//   button {
//     margin: 0;
//   }
// `;
